module.exports = __webpack_public_path__ + "static/media/1.question.9c4d4b95.mp4";